import React from "react";
import { useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import { ICON_CHEVRON_LEFT } from "../../../utils/useIcons";
import {
  STYLE_BUTTON_ICON_LEFT,
  STYLE_PADDING_WINDOWS,
} from "../../../utils/useStyle";
import ProgramClickBack from "../functions/Program.ClickBack";

const ProgramGoBackProgram = ({
  title,
  classname = "",
  textcolor,
  classNameIcon = "",
  icon,
  classNameProgram,
  onCLickNavigate,
  classNameFlex = " flex items-center gap-2 ",
}) => {
  const navigate = useNavigate();

  const { language } = React.useContext(ContextLanguage);

  return (
    <div
      className={`${
        language === "TH"
          ? " text-sm-th md:text-lg-th "
          : " text-sm md:text-lg "
      } items-center text-white font-semibold flex justify-between xl:px-44 ${STYLE_PADDING_WINDOWS} ${classname}`}
    >
      <ICON_CHEVRON_LEFT
        className={STYLE_BUTTON_ICON_LEFT}
        onClick={() => {
          ProgramClickBack(navigate);
        }}
      />
      <div className={` ${classNameFlex} . ${classNameProgram}`}>
        <div className={classNameIcon}>{icon}</div>
        <div className={textcolor} onClick={onCLickNavigate}>
          {title}
        </div>
      </div>
    </div>
  );
};

export default ProgramGoBackProgram;
